import 'simplelightbox/dist/simple-lightbox.jquery.min';
import 'slick-carousel/slick/slick';
import 'slick-lightbox-latest/dist/slick-lightbox.min';
import gtag from '../../tracker/gtag';
import gtag_event from './gtag-init';
import './whatsapp-submission';
import './virtual-submission';
import './compare-property';

export default {
  init() {
    // <!------------------ Event Tracker
    // track pageview
    setTimeout(function () {
      gtag_event('Visit');
    }, 1500);

    // WORKAROUND: passive listeners to improve scrolling performance 
    // https://stackoverflow.com/a/62177358
    jQuery.event.special.touchstart = {
      setup: function( _, ns, handle ) {
        this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
      },
    };
    jQuery.event.special.touchmove = {
      setup: function( _, ns, handle ) {
        this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
      },
    };
    jQuery.event.special.wheel = {
      setup: function( _, ns, handle ){
        this.addEventListener('wheel', handle, { passive: true });
      },
    };
    jQuery.event.special.mousewheel = {
      setup: function( _, ns, handle ){
        this.addEventListener('mousewheel', handle, { passive: true });
      },
    }

    // scroll event
    var content = $('section');
    var current_section_id = null;
    $(window).on('scroll', function (e) {
      e.preventDefault();
      let el = content.filter(function (i, el) {
        return el.getBoundingClientRect().bottom >= parseInt($(el).css('height'))
      });
      let section_id = el.prev().is(content) ? el.prev('section').attr('id') : content.eq(-1).attr('id');

      if (section_id != current_section_id) {
        current_section_id = section_id;

        // track pageview
        gtag_event('Vertical Scroll', current_section_id);
      }

      check_scroll_position(current_section_id);
    });

    function check_scroll_position(current_section_id) {
      let the_end_of_section = 'section-footer';
      let scroll_height = $(document).height();
      let scroll_position = $(window).height() + $(window).scrollTop();

      if ((scroll_height - scroll_position) / scroll_height === 0 && current_section_id != the_end_of_section) {
        gtag_event('Vertical Scroll', the_end_of_section);
      }
    }

    // promo img clicked event
    $('#section-promo img').on('click', function () {
      gtag_event('Promo Image Clicked', 'image1');
    });

    // event click about-us img
    $('.section-about-us img').on('click', function () {
      let img_idx = $(this).data('position');
      gtag_event('About-Us Image Clicked', img_idx);
    });

    let galleryElement = $('#gallery-tab a');
    if (galleryElement.length) {
      galleryElement.on('click', function () {
        let tabText = $(this).text();

        gtag_event('Gallery Tab Clicked', $.trim(tabText));
      });
    }

    let clusterElement = $('#cluster-tab a');
    if (clusterElement.length) {
      clusterElement.on('click', function () {
        let tabText = $(this).text();

        gtag_event('Cluster Tab Clicked', $.trim(tabText));
      });
    }

    // image clicked event
    let imageDetails = [
      ['.unit-type img', 'Unit Type Image Clicked'],
    ];

    $.each(imageDetails, function (key, eventDetails) {
      let element = $(eventDetails[0]);
      let eventName = eventDetails[1];

      if (element.length) {
        element.on('click', function () {
          let imgSrc = $(this).attr('src');
          let imgNameIndex = imgSrc.lastIndexOf('/') + 1;
          let imgFilename = imgSrc.substr(imgNameIndex);

          gtag_event(eventName, imgFilename);
        });
      }
    });

    // facility image clicked
    $('.simple-lightbox-facility').on('init', function () {
      $('.slick-slide').on('click', function () {
        let title = $(this).find('.facility-title').text();
        gtag_event('Facility Image Clicked', title);
      });

      $('.facility-slider .slick-arrow.btn-prev').on('click', function () {
        gtag_event('Facility Arrow Clicked', 'prev');
      });

      $('.facility-slider .slick-arrow.btn-next').on('click', function () {
        gtag_event('Facility Arrow Clicked', 'next');
      });
    });

    // faq clicked event
    $('.section-faq .card-header').on('click', function () {
      gtag_event('FAQ Clicked', $(this).attr('id'));
    });

    // footer menu clicked event
    $('#section-footer .menu-item a').on('click', function () {
      gtag_event('Footer Menu Clicked', $(this).text());
    });
    // ------------------!> The End of Event Tracker

    // image gallery
    let i;
    let elementLightBox;
    for (i = 1; i <= 10; i++) {
      elementLightBox = $('.simple-lightbox-' + i + ' a');
      if (elementLightBox.length) {
        elementLightBox.simpleLightbox();
      }
    }

    // slick carousel settings
    $('.facility-slider').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev">&lt;</button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next">&gt;</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      }],
    });

    $('.project-recommendation-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#8A8D94"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#8A8D94"/></svg></button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1.1,
        },
      }],
    });

    // slick carousel settings
    $('.virtual-tour-slides').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      dots: true,
      lazyLoad: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.666646 13.3797C0.666646 13.0172 0.822839 12.6546 1.13523 12.3781L15.0698 0.0463866L17.3333 2.04956L4.53053 13.3797L17.3333 24.7099L15.0698 26.7131L1.13523 14.3813C0.822839 14.1049 0.666646 13.7423 0.666646 13.3797Z" fill="white"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.3334 13.3797C17.3334 13.0172 17.1772 12.6546 16.8648 12.3781L2.93022 0.0463866L0.666687 2.04956L13.4695 13.3797L0.666688 24.7099L2.93022 26.7131L16.8648 14.3813C17.1772 14.1049 17.3334 13.7423 17.3334 13.3797Z" fill="white"/></svg></button>',
      slidesPerRow: 1,
    });

    $('.simple-lightbox-facility').slickLightbox();

    // load gmap
    function pageTemplateLoadGmap() {
      let mapContainerClass = '.project-map';
      let mapImgElm = $(mapContainerClass + ' img');
      let mapInputIframeElm = $(mapContainerClass + ' input[type="hidden"]');

      if (!mapImgElm.length || !mapInputIframeElm.length) {
        return false;
      }

      mapImgElm.on('click', function () {
        // $(mapContainerClass).html(mapInputIframeElm.val());
        // get relative Map to the clicked element
        const CONTAINER = $(this).parent();
        const IFRAME_ELM = $(this).siblings('input[type="hidden"]')
        CONTAINER.html(IFRAME_ELM.val());
        
        // send GA tracking
        gtag_event('Map Clicked');
      });
    }
    pageTemplateLoadGmap();

    $(window).on('scroll', function (e) {
      e.preventDefault();
      let currentHeight = $(window).scrollTop();
      let headerHeight = 90;
      let elmHeader = $('.site-header');
      let stickyClass = 'sticky-top';
      let stickyClassOn = 'sticky-top-on';

      if (currentHeight > headerHeight && elmHeader.hasClass(stickyClass) && !elmHeader.hasClass(stickyClassOn)) {
        elmHeader.addClass(stickyClassOn);
      } else if (currentHeight <= headerHeight && elmHeader.hasClass(stickyClass)) {
        elmHeader.removeClass(stickyClassOn);
      }
    });

    $('.cluster-tab-content .btn-more').on('click', function () {
      let unit_class = $(this).data('unit-class');
      let unit_class_changed = '.' + unit_class + ':gt(2)';
      let unit_show = $(this).data('unit-show');
      let class_hide = 'd-none';

      if (unit_show == 0) {
        $(unit_class_changed).removeClass(class_hide);
      } else {
        $(unit_class_changed).addClass(class_hide);
      }

      s_cluster_change_btn_more($(this));
    });

    function s_cluster_change_btn_more(btn) {
      if (btn.data('unit-show') == 0) {
        btn.data('unit-show', 1);
        btn.text('Lihat lebih sedikit');

        // event track
        gtag('Cluster Button Clicked', 'Show More Unit');
      } else {
        btn.data('unit-show', 0);
        btn.text('Lihat lebih banyak');

        // event track
        gtag('Cluster Button Clicked', 'Show Less Unit');
      }
    }

    $('.unit-detail-link').on('click', function () {
      clone_unit_type($(this).data('unit-id'));

      // event track
      gtag_event('Detail Unit Button Clicked', 'unit-' + $(this).data('unit-name'));
    });

    $('#section-cluster .btn-more').on('click', function () {
        gtag_event('Unit Type More Clicked', 'cluster');
    });
    
    function clone_unit_type(unit_id) {
      let unit_title_elm = '#unit-info-' + unit_id + ' .unit-title';
      let unit_type_elm = '#unit-type-' + unit_id;
      let unit_detail_elm = '#unit-detail-wrap-' + unit_id;
      let container_elm = '#unit-type-modal .unit-type';
      let new_unit_type_id = 'unit-type-clone';
      let new_unit_type_detail_id = 'unit-type-detail-clone';

      // clone content
      $(container_elm).text('');
      $('#unit-type-modal-label').html('<h4>' + $(unit_title_elm).text() + '</h4>');
      $(unit_type_elm).clone().attr('id', new_unit_type_id).appendTo($(container_elm));
      $(unit_detail_elm).clone().attr('id', new_unit_type_detail_id).appendTo($(container_elm));

      // change id
      $('#' + new_unit_type_id + ' .carousel-control-prev').attr('href', '#' + new_unit_type_id);
      $('#' + new_unit_type_id + ' .carousel-control-next').attr('href', '#' + new_unit_type_id);
      $('#' + new_unit_type_id + ' .carousel-indicators li').attr('data-target', '#' + new_unit_type_id);
      $('#' + new_unit_type_id + ' .carousel-item').removeClass('simple-lightbox-2');
      /*
      $('#' + new_unit_type_id + ' .carousel-item').addClass('simple-lightbox-modal-2');
      $('.simple-lightbox-modal-2 a').simpleLightbox();
      */
      $('#' + new_unit_type_detail_id + ' .description').removeClass('d-none');

      $('#' + new_unit_type_id + ' .carousel-item a').on('click', function () {
        return false;
      });

      $('#unit-type-modal').modal('show');
    }

    // play video on modal
    var videoSrc;
    var modalVideoPlayerElm = '#modalVideoPlayer';
    var modalVideoIframeElm = '#modalVideoIframe';
    var imageName;

    $('.play-video-on-modal').click(function () {
      videoSrc = $(this).data('video-src');
      imageName = $(this).data('image');
      $(modalVideoIframeElm).attr('src', videoSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
      gtag_event('Button Video Clicked', videoSrc);
      console.log(videoSrc, imageName);
    });

    // stop playing the youtube video when I close the modal
    $(modalVideoPlayerElm).on('hide.bs.modal', function () {
      $(modalVideoIframeElm).attr('src', videoSrc);
    });

    // virtual tour slick carousel settings
    $('.facility-slider').not('.slick-initialized').slick({
      mobileFirst: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev">&lt;</button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next">&gt;</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
        },
      }],
    });

    // location maps / section-v2
    if ($('.location-maps').length) {
      const LABEL_MORE = 'Lihat Lebih Banyak <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.652344 2.08768L2.3494 0.390625L9.75087 7.7921L17.1523 0.390625L18.8494 2.08768L9.75087 11.1862L0.652344 2.08768Z" fill="#FFFFF"/> </svg>';
      const LABEL_LESS = 'Lihat Lebih Sedikit <svg width="19" height="12" viewBox="0 0 19 12" fill="none" version="1.1" id="svg4" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M 0.652344,9.489145 9.75087,0.390625 18.8494,9.489145 17.1523,11.1862 9.75087,3.784725 2.3494,11.1862 Z" fill="#FFFFF" id="path2" /> </svg>';
      $('.location-maps .cta-buttons .see-more').on('click', function (e) {
        e.preventDefault();
        const descriptionDOM = $(this).parent('.cta-buttons').siblings('.location-maps-description');
        descriptionDOM.toggleClass('text-part');

        if (descriptionDOM.hasClass('text-part')) {
          // event See Less
          $(this).html(LABEL_MORE);
          gtag_event('Location Description See Less', 'Location');
        } else {
          // event See More
          $(this).html(LABEL_LESS);
          gtag_event('Location Description See More', 'Location');
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the page template, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/page-template/lgp/page.js